import axios from 'axios'

const state = () => ({
  permissions: localStorage.getItem('permissions') || [],
})

// getters
const getters = {

}

// actions
const actions = {
  getPermission: async function ({ state, commit, rootState }, payload) {
    return axios({
      method: 'get',
      url: '/api/user_permission/' + payload.id,
      headers: { Authorization: 'Bearer ' + rootState.token },
    }).then(response => {
      commit('getPermisos', response.data)
    }).catch(error => {
      commit('toast/show', { tipo: 'error', messages: error.response.data.errors }, { root: true })
    })
  },
  setPermissions: function ({ commit }, payload) {
    commit('getPermisos', payload)
  },
}

// mutations
const mutations = {
  getPermisos (state, permissions) {
    state.permissions = permissions
    localStorage.setItem('permissions', permissions)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
